import _ from "lodash";
import { fromMaterialJson, Material } from "./material";
import { RecipeStatus } from "./recipe";

export interface PaymentResult {
  id: string;
  success: boolean;
  patientName: string;
  totalAmount: number;
  realAmount: number;
  treatmentId: string;
  materials: Material[];
  state: RecipeStatus;
  createTime?: string;
  operateName?: string;
}

export function fromJson(json: any): PaymentResult {
  const payment = json.payment;
  return {
    success: true,
    id: payment?.id?.toString() || "",
    patientName: payment?.patientName,
    totalAmount: payment?.shouldPayAmount || 0,
    realAmount: payment?.realPayAmount || 0,
    materials: _.chain(json.recipeItemList)
      .map((m) => fromMaterialJson(m))
      .value(),
    state: payment?.state || RecipeStatus.ToSettle,
    treatmentId: payment?.treatmentId?.toString() || "",
    createTime: payment?.createTime,
    operateName: payment?.operateName,
  };
}
